import React from "react"

import { OutlinedInput, InputAdornment, IconButton } from "@material-ui/core";
import { toDDMMYY } from "../../utils/formatters";

import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { toast } from "react-toastify";

const CustomInputField = (props) => {
    const { classes, element, dataObj, onChange, styles, selectedStep, inputClasses } = props
    const getValueFromPath = (obj, path) => {
        if (!path) return undefined;
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
    };

    const rawValue = getValueFromPath(dataObj, element.value) || dataObj[element.name];

    let displayValue = rawValue || "";

    const extractNumber = (val) => {
        if(!val || val === '' || val === null || val === undefined)
        {
            return 0;
        }
        const s = String(val);
        return s.length > 0 ? s.length : 0;
    
    };
    
    const clampMax = (n, max = 100) => Number(n) <= max;


    if (element.showPoundIcon) {
        if (typeof displayValue === "string") {
            // Remove pound and commas
            displayValue = displayValue.replace(/£/g, "").replace(/,/g, "").trim();
        }

        const numericVal = parseFloat(displayValue);

        displayValue = !isNaN(numericVal)
            ? `£${numericVal.toLocaleString("en-GB", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            })}`
            : "£0.0";
    }
    if (element.showDollarIcon) {
        if (typeof displayValue === "string") {
            // Remove pound and commas
            displayValue = displayValue.replace(/£/g, "").replace(/,/g, "").trim();
        }

        const numericVal = parseFloat(displayValue);

        displayValue = !isNaN(numericVal)
            ? `$${numericVal.toLocaleString("en-GB", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            })}`
            : "$0.0";
    }
    else if (element.showPercentageIcon) {
        if (typeof displayValue === "string") {
            displayValue = displayValue.replace(/%/g, "").trim();
        }
        let numericVal = parseFloat(displayValue);

        if (!isNaN(numericVal)) {
            // if value looks like a fraction (0–1), convert to %
            if (numericVal <= 1) {
                numericVal = numericVal * 100;
            }

            displayValue = `${numericVal.toLocaleString("en-GB", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            })}%`;
        } else {
            displayValue = "0.0%";
        }
    }

    else if (element.isAmountField) {
        if (typeof displayValue === "string") {
            // Remove pound and commas
            displayValue = displayValue.replace(/£/g, "").replace(/,/g, "").trim();
        }

        const numericVal = parseFloat(displayValue);

        displayValue = !isNaN(numericVal)
            ? `${numericVal.toLocaleString("en-GB", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1
            })}`
            : "0.0";
    }

    const handleViewClick = (viewUrl, displayValue, isTabOpen) => {
        if(isTabOpen && props?.setActiveTabMain) {
            props.setActiveTabMain("spendDetails");
        }
        if (viewUrl && displayValue) {
            window.open(`${window.location.origin}/${props?.match?.params?.appid}/page/${element.viewUrl}/${displayValue}`, '_blank');
        }
    };

    const validateDateInput = (value, inputType) => {
        if (inputType !== 'date' || !value) {
            return value;
        }

        // For HTML5 date input, format should be YYYY-MM-DD
        // Check if year exceeds 4 digits
        const datePattern = /^(\d{4})-(\d{2})-(\d{2})$/;
        const match = value.match(datePattern);
        
        if (match) {
            const year = match[1];
            // If year is more than 4 digits, truncate to first 4 digits
            if (year.length > 4) {
                const truncatedYear = year.substring(0, 4);
                const month = match[2];
                const day = match[3];
                return `${truncatedYear}-${month}-${day}`;
            }
            return value;
        }

        // If user is typing and hasn't completed the date format yet
        // Check if they're entering more than 4 digits before the first dash
        const beforeDash = value.split('-')[0];
        if (beforeDash && beforeDash.length > 4) {
            // Truncate to 4 digits and keep the rest
            const truncatedYear = beforeDash.substring(0, 4);
            const rest = value.substring(beforeDash.length);
            return truncatedYear + rest;
        }

        return value;
    };

    return (
        <OutlinedInput
            id={`${element.name}`}
            variant="outlined"
            style={{
                width: "100%",
                height: "32px",
                padding: '5px 8px 6px 8px'
            }}
            classes={{
                root: inputClasses?.smallOutlinedInput,
                notchedOutline: inputClasses?.smallNotchedOutline,
            }}
            required={element.required}
            key={element.value || element.name}
            name={element.value || element.name}
            disabled={element.readOnly}
            type={element.type}
            value={displayValue}
            title={element.type === 'date' ? toDDMMYY(displayValue) : displayValue}
            inputProps={{
                maxLength: element.type === 'date' ? 10 : undefined, // Limit date input to YYYY-MM-DD format (10 chars)
            }}
            onPaste={(e) => {
                if (element.type === 'date' && !element.readOnly) {
                    e.preventDefault();
                }
            }}
            onKeyDown={(e) => {
                if (element.type === 'date' && !element.readOnly) {
                    e.preventDefault();
                }
            }}
            onChange={(e) => {
                const inputValue = e.target.value;
                const numericValue = extractNumber(inputValue);
                let maxLen = element.maxLength || 100;
                if (element.type === 'string' && numericValue && !clampMax(numericValue, maxLen)) {
                    toast.error(`Value cannot be greater than ${maxLen}`);
                    const validatedValue = validateDateInput(displayValue, element.type);
                    onChange((element.value || element.name), validatedValue, element.type);
                    return;
                }
                const validatedValue = validateDateInput(inputValue, element.type);
                onChange((element.value || element.name), validatedValue, element.type);
            }}
            endAdornment={
                element?.isViewEnable && displayValue && displayValue !== "" ? (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => { handleViewClick(element?.viewUrl, displayValue, element?.isTabOpen) }}
                            edge="end"
                            size="small"
                            style={{ padding: '0px', minWidth: '20px', width: '20px', height: '20px' }}
                        >
                            <OpenInNewIcon fontSize="small" style={{ fontSize: '18px' }} />
                        </IconButton>
                    </InputAdornment>
                ) : null
            }
        />
    )
}

export default CustomInputField